import _ from "lodash";

import { MENU_LIST } from "@static/MENU_LIST";
import { KEY_IMPORTANT } from "@static/PERMISSION_KEY";

const ignoreMenuList = [KEY_IMPORTANT];

export const initialMenuList = ({ userPermission }) => {
  const compactUserPermission = [...userPermission, ...ignoreMenuList];
  const renderMenu = _.chain(MENU_LIST)
    .filter((menu) => {
      console.log("menu :>> ", menu);
      const menuKey = _.get(menu, ["key"]);
      const updateMenu = _.includes(compactUserPermission, menuKey);
      console.log("updateMenu :>> ", updateMenu);
      return updateMenu;
    })
    .map((menu) => {
      const children = _.get(menu, ["children"]);
      const updateMenu = children
        ? {
            ...menu,
            children: _.filter(children, (child) => {
              const childKey = _.get(child, ["key"]);
              return _.includes(compactUserPermission, childKey);
            }),
          }
        : menu;
      return updateMenu;
    })
    .value();

  const defaultLocation = _.chain(renderMenu)
    .first()
    .thru((item) => {
      const isChildren = _.get(item, ["isChildren"]);
      const children = _.get(item, ["children"]);

      if (isChildren) {
        return _.chain(children).first().get(["location"]).value();
      }
      return _.get(item, ["location"]);
    })
    .value();

  return {
    menuList: renderMenu,
    defaultLocation,
  };
};
